import { render } from "./Button.vue?vue&type=template&id=21fe69de"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import exportComponent from "G:\\web\\webprog\\wk_hello_world\\wk_ball_01_10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__